import CaptainAmericaAvatar from "../assets/captainamerica_avatar.png";
import CyclopsAvatar from "../assets/cyclops_avatar.png";
import IronManAvatar from "../assets/ironman_avatar.png";
import SpidermanAvatar from "../assets/spiderman_avatar.png";
import WolverineAvatar from "../assets/wolverine_avatar.png";

export const users = {
    "users":[
        {
            "uid": "superhero1",
            "name": "Iron Man",
            "avatar": IronManAvatar
        },
        {
            "uid": "superhero2",
            "name": "Captain America",
            "avatar": CaptainAmericaAvatar
        },
        {
            "uid": "superhero3",
            "name": "Spiderman",
            "avatar": SpidermanAvatar
        },
        {
            "uid": "superhero4",
            "name": "Wolverine",
            "avatar": WolverineAvatar
        },
        {
            "uid": "superhero5",
            "name": "Cyclops",
            "avatar": CyclopsAvatar
        }
    ]
}